import { CARD_OFFER_TYPES } from 'constants/cards'

export const isUserEV = ({ cardOfferType } = {}) => cardOfferType === CARD_OFFER_TYPES.PULSE
